/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementReceptResponse } from './EventManagementReceptResponse';

export type EventManagementReceptResponseApiRespoonse = {
    data?: EventManagementReceptResponse;
    status?: EventManagementReceptResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementReceptResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

